<template lang="pug">
.uncertain-order-list
  el-table(:data="list" default-expand-all)
    el-table-column(type="expand")
      template(slot-scope="scope")
        el-card(shadow="hover")
          uncertain-order-list-item(
            :list="scope.row.assignOrderDTO.assignOrderItemList"
            :totalAmount="scope.row.assignOrderDTO.totalAmount"
            :totalNum="scope.row.assignOrderDTO.totalNum"
            :totalWeight="scope.row.assignOrderDTO.totalWeight"
            :warehouseName="scope.row.warehouseName"
            :pieceWeightUnit="scope.row.bizOrder.pieceWeightUnit"
            :parentOrderItemId="scope.row.itemId"
            :isAbleEdit="getIsAbleEditGoods(scope.row.assignOrderDTO.assignOrderItemList, scope.row.bizOrder.orderStatus)"
            @edit="editOrderItem"
            @refreshData="refreshData"
          )
    el-table-column(label="商品" align="left" min-width="120px")
      template(slot-scope="scope")
        .goods-name {{scope.row.itemTitle}}
        .goods-no 商品编号：{{scope.row.itemId}}
        div.goods-no(v-if="scope.row.supplierName") {{scope.row.supplierName}}
        el-tag.m-t10.tag(v-if="scope.row.bizOrder.containerFuturesGoods"
              effect="plain" size="small" type="warning") 预售
    el-table-column(label="商品属性" align="center" min-width="90px")
      template(slot-scope="scope")
        .c-9
          p.sku-title 单件重:
            span.c-3 {{scope.row.bizOrder.pieceWeight / 10000}}{{ scope.row.bizOrder.pieceWeightUnit | formatWeightUnit}}      
          p.sku-title(v-for="(kV, index) in getKVListFromKVStrList(scope.row.skuTitleList)" :key="index")
            span {{ kV.key }}：
            span.c-3 {{ kV.value }}
          p.sku-title 仓库:
            span.c-3 {{scope.row.warehouseName}}
    el-table-column(label="单价" align="center")
      template(slot-scope="scope")
        template(v-if="scope.row.bizOrder.logisticsPrice || scope.row.bizOrder.processFee || scope.row.bizOrder.storageFee || scope.row.bizOrder.commissionFee || scope.row.bizOrder.promiseInterestSubsidyFee || scope.row.bizOrder.settleAdjustFee")
          p {{ priceWithFees(scope.row) }} 元/{{ scope.row.bizOrder.pieceWeightUnit | formatWeightUnit }}
            zg-info
              div(slot="content")
                div 商品单价：{{ scope.row.itemPrice / 100 }} 元/{{ scope.row.bizOrder.pieceWeightUnit | formatWeightUnit }}
                div(v-if='scope.row.bizOrder.logisticsPrice') 胖猫物流费：{{ scope.row.bizOrder.logisticsPrice / 100 }} 元/{{ scope.row.bizOrder.pieceWeightUnit | formatWeightUnit }}
                div(v-if='scope.row.bizOrder.processFee') 加工费：{{ scope.row.bizOrder.processFee / 100 }} 元/{{ scope.row.bizOrder.pieceWeightUnit | formatWeightUnit }}
                div(v-if='scope.row.bizOrder.storageFee') 仓储费：{{ scope.row.bizOrder.storageFee / 100 }} 元/{{ scope.row.bizOrder.pieceWeightUnit | formatWeightUnit }}
                div(v-if='scope.row.bizOrder.commissionFee') 委托物流费：{{ scope.row.bizOrder.commissionFee / 100 }} 元/{{ scope.row.bizOrder.pieceWeightUnit | formatWeightUnit }}
                div(v-if='scope.row.bizOrder.promiseInterestSubsidyFee') 承兑贴息费：{{ scope.row.bizOrder.promiseInterestSubsidyFee / 100 }} 元/{{ scope.row.bizOrder.pieceWeightUnit | formatWeightUnit }}
                div(v-if='scope.row.bizOrder.settleAdjustFee') 结算调差费：{{ scope.row.bizOrder.settleAdjustFee / 100 }} 元/{{ scope.row.bizOrder.pieceWeightUnit | formatWeightUnit }}
              
        template(v-else)
          p {{ scope.row.itemPrice / 100 }} 元/{{ scope.row.bizOrder.pieceWeightUnit | formatWeightUnit }}

    el-table-column(label="数量" align="center" prop="buyAmount")
    el-table-column(label="重量" align="center")
      template(slot-scope="scope")
        p {{scope.row.bizOrder.totalWeight / 10000}}{{ scope.row.bizOrder.pieceWeightUnit | formatWeightUnit }}
    el-table-column(label="小计金额" align="center")
      template(slot-scope="scope")
        .goods-piece-weight.c-red(v-if="getIsShowActualTotalFeeByOrderStatus(scope.row.bizOrder.orderStatus)")
          template(v-if="scope.row.bizOrder.logisticsTotalFee || scope.row.bizOrder.processTotalFee || scope.row.bizOrder.storageTotalFee || scope.row.bizOrder.commissionTotalFee || scope.row.bizOrder.promiseInterestSubsidyTotalFee || scope.row.bizOrder.settleAdjustTotalFee")
            p {{ scope.row.bizOrder.actualTotalFee | currencyFormat }}
              zg-info
                div(slot="content")
                  div 商品小计：{{ scope.row.bizOrder.obligationTotalFee | currencyFormat }}
                  div(v-if='scope.row.bizOrder.logisticsTotalFee') 胖猫物流金额：{{ scope.row.bizOrder.logisticsTotalFee | currencyFormat }}
                  div(v-if='scope.row.bizOrder.processTotalFee') 加工费金额：{{ scope.row.bizOrder.processTotalFee | currencyFormat }}
                  div(v-if='scope.row.bizOrder.storageTotalFee') 仓储费金额：{{ scope.row.bizOrder.storageTotalFee | currencyFormat }}
                  div(v-if='scope.row.bizOrder.commissionTotalFee') 委托物流费金额：{{ scope.row.bizOrder.commissionTotalFee | currencyFormat }}
                  div(v-if='scope.row.bizOrder.promiseInterestSubsidyTotalFee') 承兑贴息金额：{{ scope.row.bizOrder.promiseInterestSubsidyTotalFee | currencyFormat }}
                  div(v-if='scope.row.bizOrder.settleAdjustTotalFee') 结算调差金额：{{ scope.row.bizOrder.settleAdjustTotalFee | currencyFormat }}

          template(v-else)
            p {{ scope.row.bizOrder.actualTotalFee | currencyFormat }}
    el-table-column(label="待指认量" align="center")
      template(slot-scope="scope")
        p {{scope.row.assignWeightAmount / 10000}}{{ scope.row.bizOrder.pieceWeightUnit | formatWeightUnit }}
    el-table-column(label="操作" align="center" min-width="80px")
      template(slot-scope="scope")
        //- isShowGuide用来当显示引导的时候有按钮可获取位置信息 class用来获取组件内按钮
        div(v-show="getIsAbleEditGoods(scope.row.assignOrderDTO.assignOrderItemList, scope.row.bizOrder.orderStatus) || isShowGuide")
          zg-button(label="指认商品" type="text--main" @click="openDialog('add', scope.row)")
          zg-button(class="confirm-btn" label="完成指认" type="text" @click="confirm(scope.row)")

  // 指认商品弹窗 - start
  el-dialog(
    :visible.sync="dialog.isShow"
    :close-on-click-modal="false"
    title="指认商品"
    width="1200px"
    center
    @close="resetDialogData"
  )
    uncertain-order-assign(
      v-if="dialog.isShow"
      :mode="dialog.mode"
      :to-assign-spu="dialog.toAssignSpu" 
      :sub-order-id="dialog.subOrderId"
      :to-edit-sku="dialog.toEditSku"
      @leave="closeDialog"
      @refreshData="refreshData"
    )
  // 指认商品弹窗 - end
</template>

<script>
import UncertainOrderListItem from './uncertainOrderListItem'
import UncertainOrderAssign from './uncertainOrderAssign'
import ZgInfo from '@/components/zg-info'
import ZgButton from '@/components/zg-button'
import { getIsAbleEditGoods } from '../helper'
export default {
  name: 'UncertainOrderList',
  components: {
    UncertainOrderListItem,
    UncertainOrderAssign,
    ZgInfo,
    ZgButton
  },
  props: {
    list: {
      type: Array
    },
    isShowGuide: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      dialog: {
        isShow: false,
        mode: '',
        toAssignSpu: {}, // 待指认商品
        toEditSku: {}, // 待编辑 sku
        subOrderId: null // 子订单 id
      }
    }
  },
  methods: {
    openDialog(mode, toAssignSpu, toEditSku) {
      this.dialog.mode = mode
      const {
        itemTitle,
        itemId,
        skuTitleList,
        itemPrice,
        buyAmount,
        bizOrder,
        assignWeightAmount,
        assignMoneyAmount,
        categoryId,
        warehouseName,
        pieceWeight,
        valuationUnitWay,
        supplierName
      } = toAssignSpu
      const {
        totalWeight,
        orderStatus,
        pieceWeightUnit,
        bizOrderId,
        logisticsWay,
        logisticsPrice,
        logisticsTotalFee,
        obligationTotalFee,
        actualTotalFee,
        processFee,
        storageFee,
        commissionFee,
        promiseInterestSubsidyFee,
        settleAdjustFee,
        processTotalFee,
        storageTotalFee,
        commissionTotalFee,
        promiseInterestSubsidyTotalFee,
        settleAdjustTotalFee
      } = bizOrder
      console.log('orderList toAssignSpu', toAssignSpu)

      this.dialog.toAssignSpu = {
        supplierName,
        itemTitle,
        itemId,
        spuProps: this.getKVListFromKVStrList(skuTitleList),
        itemPrice,
        buyAmount,
        totalWeight,
        isShowActualTotalFee: this.getIsShowActualTotalFeeByOrderStatus(orderStatus),
        logisticsTotalFee,
        obligationTotalFee,
        actualTotalFee,
        pieceWeightUnit,
        assignWeightAmount,
        assignMoneyAmount,
        categoryId,
        warehouseName,
        pieceWeight,
        valuationUnitWay,
        logisticsWay, // 配送方式 1自提 2商家配送
        logisticsPrice, // 运费单价
        steelMill: '', // 钢厂
        bundleNo: '', //捆包号·
        processFee,
        storageFee,
        commissionFee,
        promiseInterestSubsidyFee,
        settleAdjustFee,
        processTotalFee,
        storageTotalFee,
        commissionTotalFee,
        promiseInterestSubsidyTotalFee,
        settleAdjustTotalFee
      }
      this.dialog.subOrderId = bizOrderId
      if (mode === 'edit') {
        this.dialog.toEditSku = { ...toEditSku }
      }
      this.dialog.isShow = true
    },
    // 关闭弹窗
    closeDialog() {
      this.dialog.isShow = false
    },
    // 清空弹窗数据
    resetDialogData() {
      this.dialog.mode = ''
      this.dialog.toAssignSpu = {} // 待指认 spu
      this.dialog.toEditSku = {} // 待编辑 sku
      this.dialog.subOrderId = null // orderItem id
    },
    editOrderItem(parentOrderItemId, orderItem) {
      console.log('orderList editOrderItem', parentOrderItemId, orderItem)

      const toAssignSpu = this.list.find(l => l.itemId === parentOrderItemId)
      if (toAssignSpu) {
        this.openDialog('edit', toAssignSpu, orderItem)
        console.log('orderList editOrderItem openDialog', toAssignSpu, orderItem)
      }
    },
    // 完成指认
    async confirm({ assignOrderDTO, bizOrder }) {
      const { assignOrderItemList } = assignOrderDTO
      const { bizOrderId } = bizOrder
      if (assignOrderItemList && assignOrderItemList.length > 0) {
        const { data, success } = await this.$post('trademanager.comfirmOrderItemForSeller', {
          subBizOrderId: bizOrderId
        })
        if (success) {
          if (data[0].value) {
            this.$message.success('已完成指认')
            this.refreshData()
          } else {
            this.$message.error('操作失败，请稍后再试...')
          }
        }
      } else {
        this.$message.warning('请先指认商品')
      }
    },
    refreshData() {
      this.$emit('refreshData')
    },
    // [List] '计量方式:抄码' => { key: '计量方式': val: '抄码' }
    getKVListFromKVStrList(kVsStrList = []) {
      return kVsStrList.map(kVStr => {
        const arr = kVStr.split(':')
        return {
          key: arr[0],
          value: arr[1] || '-'
        }
      })
    },
    getIsShowActualTotalFeeByOrderStatus(orderStatus) {
      return ![
        'WAITING_PAY',
        'CANCEL',
        'NO_PAY_WAITING_FINISH',
        'NO_PAY_WAITING_DELIVERY',
        'NO_PAY_WAITING_SHIPPING'
      ].includes(orderStatus)
    },
    // 是否已指认的状态挂在 orderItem 的明细层，因为据后端描述：orderItem 纬度
    // status	1：已创建，2：已完成指派，3：取消 只要有一条数据状态为2则 orderItem 都不可编辑
    getIsAbleEditGoods,
    priceWithFees(row) {
      return (
        (row.itemPrice +
          row.bizOrder.logisticsPrice +
          (row.bizOrder.processFee || 0) +
          (row.bizOrder.storageFee || 0) +
          (row.bizOrder.commissionFee || 0) +
          (row.bizOrder.promiseInterestSubsidyFee || 0) +
          (row.bizOrder.settleAdjustFee || 0)) /
        100
      )
    }
  },
  mounted() {}
}
</script>

<style lang="stylus" scoped>
.uncertain-order-list {
  & >>> .el-table {
    .el-table__expanded-cell {
      padding: 5px 10px 20px;
    }
  }

  .el-button + .el-button {
    margin-left: 0;
  }
}
</style>
